<template>
<div>
  <div class="card card-form">
    <div class="card-header" >
      <div class="row" >
        <div class="col-12">
          <div class="pull-left">
            <h4 class="card-title float-left" >
              <span><i class="fa fa-role"></i>
                <label class="label">{{title}} <code>*</code></label>
              </span>
            </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" >
      <check-box
          v-for="option in options"
          :checked="action!=='ADD' && value.some(e => e.trim() === option.code.trim())"
          :disabled="option.disabled"
          @change-multi-checkbox:checked="check(option, $event)"
          :fieldId="option.code"
          :label="option.name"
          :key="option.code"

      />

    </div>
    <div class="card-footer">

    </div>

  </div>
</div>
</template>

<script>
import Checkbox from "./checkbox.vue";

export default {
  emits: ["update:value"],
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
      required: true,
      // validator: (value) => {
      //   const hasNameKey = value.every((option) =>
      //       Object.keys(option).includes("name")
      //   );
      //   const hasIdKey = value.every((option) =>
      //       Object.keys(option).includes("id")
      //   );
      //   return hasNameKey && hasIdKey;
      // },
    },
    action: {
      type: String,
      default: "EDIT",
    }
  },
  // setup(props, context) {
  //   const check = (optionId, checked) => {
  //     let updatedValue = [...props.value];
  //     if (checked) {
  //       updatedValue.push(optionId);
  //     } else {
  //       updatedValue.splice(updatedValue.indexOf(optionId), 1);
  //     }
  //     context.emit("update:value", updatedValue);
  //   };
  //
  //   return {
  //     check,
  //   };
  // },
  methods: {
    check(option, event) {
      console.log(option);
      console.log(event);


      // if (this.value.some(e => e === 'ROLE_FINANCIER')) {
      //   this.$swal({
      //     title: this.$t('messages.common.warning'),
      //     text: this.$t('messages.common.errorOccurred'),
      //     type: 'warning',
      //     html: "Оддий фойдаланувчи>>бошка рол бўлиши мумкин эмас!."
      //   });
      //   return;
      // }

      // console.log(this.value, option, event);
      // let updatedValue = [this.props.value];
      if (event) {
        this.value.push(option.code.trim());
      } else {
        this.value.splice(this.value.indexOf(option.code.trim()), 1);
      }
      console.log(this.value);

      // this.$emit('change-multi-checkbox', this.value);
      this.$emit('change', this.value, option, event);


    }
  },
  components: {
    "check-box": Checkbox,
  },
  mounted() {
    console.log("this.value");
    console.log(this.value);
  },
};
</script>
